import { render, staticRenderFns } from "./AverageCallDuration.vue?vue&type=template&id=f599f9e6&scoped=true"
import script from "./AverageCallDuration.vue?vue&type=script&lang=js"
export * from "./AverageCallDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f599f9e6",
  null
  
)

export default component.exports